import { icons } from "lucide-react";

export function Icon({ name, ...props }) {
  const C = (icons && icons[name]) || icons.Circle;
  return <C {...props} />;
}
